import storage from '@Ravnur-Inc/helpers/storage';

import { STORAGE_GROUP, STORAGE_COOKIE_KEY } from '../constants';

export function refreshCookieName(name: string) {
  storage.set(STORAGE_GROUP, STORAGE_COOKIE_KEY, name);
}
